export default __webpack_public_path__ + "static/media/us-interstate-wide.e2445d64.svg";